export enum PaymentTypeValues {
  BankAccount = "P",
  Postal = "A",
  Inkaso = "I",
  Sipo = "E",
  Iban = "B",
}

export enum InvoicesSendingTypeValues {
  Mail = "MAIL",
  Postal = "POSTAL",
  B2C = "B2C",
  B2B = "B2B",
}

export const ELECTRICITY_MIN_DEPOSIT_HOUSEHOLD = 350;
export const ELECTRICITY_MIN_DEPOSIT_COMPANY = 400;
export const GAS_MIN_DEPOSIT = 200;
